module.exports = __webpack_public_path__ + "static/media/pensions.91a3d280.svg";